(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fsg-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fsg-media-gallery')) {
    customElements.define('fsg-media-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.panels = [...this.querySelectorAll('[data-media-panel]')];
        this.thumbnails = [...this.querySelectorAll('[data-gallery-target]')];
        this.index = Math.max(0, this.panels.findIndex(panel => !panel.hidden));
        this.dialog = this.querySelector('dialog');
        this.fullImage = this.querySelector('[data-full-image]');
        this.addEventListener('click', event => {
          const thumb = event.target.closest('[data-gallery-target]');
          if (thumb) this.show(this.panels.findIndex(panel => panel.id === thumb.dataset.galleryTarget));
          if (event.target.closest('[data-gallery-prev]')) this.show(this.index - 1);
          if (event.target.closest('[data-gallery-next]')) this.show(this.index + 1);
          const zoom = event.target.closest('[data-zoom-src]');
          if (zoom) {
            if (this.swipedAt && Date.now() - this.swipedAt < 500) return;
            this.returnFocus = zoom;
            this.fullImage.src = zoom.dataset.zoomSrc;
            this.fullImage.alt = zoom.dataset.zoomAlt;
            this.dialog.classList.remove('is-detail');
            this.querySelector('[data-dialog-zoom]').setAttribute('aria-pressed', 'false');
            this.dialog.showModal();
          }
          if (event.target.closest('[data-dialog-close]')) this.dialog.close();
          if (event.target.closest('[data-dialog-zoom]')) {
            const detailed = this.dialog.classList.toggle('is-detail');
            this.querySelector('[data-dialog-zoom]').setAttribute('aria-pressed', String(detailed));
          }
        });
        this.dialog.addEventListener('close', () => this.returnFocus?.focus());
        this.querySelector('.fsg-gallery__thumbnails')?.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const current = this.thumbnails.indexOf(document.activeElement);
          let next = event.key === 'Home' ? 0 : event.key === 'End' ? this.thumbnails.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1);
          next = (next + this.thumbnails.length) % this.thumbnails.length;
          this.thumbnails[next].focus();
          this.show(next);
        });
        let touchStart = null;
        const stage = this.querySelector('.fsg-gallery__stage');
        stage.addEventListener('touchstart', event => {
          if (event.touches.length === 1 && event.target.closest('[data-zoom-src]')) touchStart = {x: event.touches[0].clientX, y: event.touches[0].clientY};
          else touchStart = null;
        }, {passive: true});
        stage.addEventListener('touchend', event => {
          if (!touchStart) return;
          const touch = event.changedTouches[0];
          const dx = touch.clientX - touchStart.x;
          const dy = touch.clientY - touchStart.y;
          touchStart = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            this.swipedAt = Date.now();
            this.show(this.index + (dx < 0 ? 1 : -1));
          }
        }, {passive: true});
      }
      show(index) {
        if (!this.panels.length || index < -1) return;
        const next = (index + this.panels.length) % this.panels.length;
        this.panels.forEach((panel, i) => {
          if (i !== next && !panel.hidden) {
            panel.querySelectorAll('video').forEach(video => video.pause());
            panel.querySelectorAll('iframe').forEach(frame => { const src = frame.getAttribute('src'); if (src) frame.setAttribute('src', src); });
            panel.querySelectorAll('model-viewer').forEach(model => model.pause?.());
          }
          panel.hidden = i !== next;
        });
        this.index = next;
        this.thumbnails.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === next)));
        this.thumbnails[next]?.scrollIntoView({block: 'nearest', inline: 'nearest', behavior: 'instant'});
        const status = this.querySelector('[data-gallery-status]');
        if (status) status.textContent = status.dataset.statusTemplate.replace('__CURRENT__', String(next + 1));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
